import { useMemo } from "react";
import { motion } from "framer-motion";

const defaultHeaderImages = [
  "/storage/categories/banners/kafshmajlesi.webp",
  "/storage/categories/banners/kafshsport.webp",
  "/storage/categories/banners/sandal.webp",
  "/storage/categories/banners/kafshpersnelo.webp"
];

const Header = ({ children, image }) => {
  const fallbackImage = useMemo(() => {
    const index = Math.floor(Math.random() * defaultHeaderImages.length);
    return defaultHeaderImages[index];
  }, []);

  const headerImage = image || fallbackImage;

  return (
    <motion.header
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="header"
      style={{ backgroundImage: `url(${headerImage})` }}
    >
      <div className="header-cover">
        <div className="my-container flex-y h-[300px]">
          <h1 className="header-heading">{children}</h1>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
